module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/widget-consultas.86afbee7.svg";